import {
  boxRatioWidth,
  suggestResponsiveBoxRatioForServices,
} from "../../helpers/general";

export function calcWidth() {
  let percent =
    (boxRatioWidth({
      columns: suggestResponsiveBoxRatioForServices().column,
      padding: suggestResponsiveBoxRatioForServices().padding,
    }) *
      40) /
    100;
  if (percent > 75) {
    return 75;
  } else {
    return percent;
  }
}

export function findLeastPrice(service) {
  let output = [];
  if (service.children.length === 0) {
    service.pricing.map((item) => {
      if (item.price > 0) {
        output.push(item.price);
      }
    });
  } else {
    service.children.map((item) => {
      item.pricing.map((i) => {
        if (i.price > 0) {
          output.push(i.price);
        }
      });
    });
  }
  output.sort((a, b) => {
    return a - b;
  });
  if (output[0]) {
    return output[0];
  }
  return "";
}
